const state = () => ({
  isValid: false,
  question: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  question(state) {
    return state.question;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateQuestion(state, payload) {
    state.question = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

export const hrbOrderQuestionText = {
  state,
  getters,
  mutations,
  namespaced: true
};
